<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M439.463,61.781c-4.616-2.685-10.318-2.685-14.933,0c-17.869,9.948-38.002,15.121-58.453,15.019
			c-29.891,0.661-58.793-10.715-80.213-31.573c-24.728-24.205-58.162-37.431-92.757-36.693
			c-27.861-0.241-55.101,8.232-77.909,24.235V25.6c0-14.138-11.461-25.6-25.6-25.6c-14.139,0-25.6,11.461-25.6,25.6v460.8
			c0,14.138,11.461,25.6,25.6,25.6c14.138,0,25.6-11.461,25.6-25.6V264.533c2.828-0.265,5.522-1.33,7.765-3.072
			c20.302-14.951,44.933-22.861,70.144-22.528c29.946-0.688,58.911,10.689,80.384,31.573c24.681,24.17,58.049,37.394,92.587,36.693
			c26.469,0.308,52.431-7.266,74.581-21.76c4.74-3.285,7.501-8.742,7.339-14.507V76.8C448.083,70.618,444.818,64.872,439.463,61.781
			z M98.13,486.4c0,4.713-3.82,8.533-8.533,8.533c-4.713,0-8.533-3.82-8.533-8.533V25.6c0-4.713,3.82-8.533,8.533-8.533
			c4.713,0,8.533,3.82,8.533,8.533V486.4z M430.93,271.275c-19.319,12.47-41.86,19.025-64.853,18.859
			c-29.891,0.661-58.793-10.715-80.213-31.573c-24.728-24.205-58.162-37.431-92.757-36.693
			c-27.843-0.297-55.083,8.117-77.909,24.064V54.784c21.312-19.284,49.173-29.72,77.909-29.184
			c29.946-0.688,58.911,10.689,80.384,31.573c24.681,24.17,58.049,37.394,92.587,36.693c22.598,0.158,44.882-5.296,64.853-15.872
			V271.275z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
